import { parse } from 'qs';
import { apiBaseUrls } from '@saucelabs/sl-util-config';

export const getAll = (location = {}) => parse(location.search, { ignoreQueryPrefix: true });
export const get = (location, key) => getAll(location)[key];
export const set = (location, params) => ({ ...getAll(location), ...params });
export const remove = (location, key, value) => {
  const existingQueryParams = getAll(location);
  const existingQueryValue = existingQueryParams[key];
  if (value && Array.isArray(existingQueryValue)) {
    const remainingValue = existingQueryValue.filter((queryValue) => queryValue !== value);
    if (remainingValue.length) {
      return { ...existingQueryParams, [key]: remainingValue };
    }
    delete existingQueryParams[key];
  } else if (Array.isArray(key)) {
    key.forEach((currentKey) => {
      delete existingQueryParams[currentKey];
    });
  } else {
    delete existingQueryParams[key];
  }
  return existingQueryParams;
};

export const extractQueryStringFromAPI = ({ api, baseUrl = apiBaseUrls.testPatterns }) => {
  const url = new URL(`${baseUrl}${api}`);
  return getAll(url);
};
